import CategoryLeadersMethodology from './CategoryLeadersMethodology'

export default CategoryLeadersMethodology
